import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength, email as emailVal } from 'vuelidate/lib/validators';
import { ROLES_VALUES } from '@/tools/values/staff.values';
import { STAFF_STORE } from '@/tools/store/staff.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { StaffService } from '@/tools/services/staff.service';

@Component({
  name: 'ed-create-staff'
})
export default class EdCreateStaffComponent extends Vue {

  /* Props */
  @Prop() readonly orgId: number;

  /* Data */
  public form: any = {}
  public isSaving: boolean = false
  public roles: any = ROLES_VALUES
  public roleSelected: string = ''

  /* Methods */
  private init(firstName = '', lastName = '', email = '') {
    this.form = EdFormModel([
      EdInputModel('firstName', firstName, {required, maxLength: maxLength(60)}),
      EdInputModel('lastName', lastName, {required, maxLength: maxLength(60)}),
      EdInputModel('email', email, {required, emailVal})
    ]);
  }

  public cancel() {
    this.$edEventBus.$emit('closeCreateStaff');
    this.init();
  }
  
  public inviteUser() {
    this.isSaving = true;
    let formData = {
      'email': this.form.email.value,
      'firstName': this.form.firstName.value,
      'lastName': this.form.lastName.value,
      'roleType': this.roleSelected
    }
    StaffService.inviteUser([formData], this.orgId)
    .then(() => {
      this.isSaving = false;
      this.$edEventBus.$emit('closeCreateStaff');
      this.init();
      this.$store.commit(STAFF_STORE.MUTATIONS.RESET_USERS_M);
      this.$EdToast.create({ 
        msg:  `${this.$t('tools.staff.success.userInvited')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
    }).catch(() => {
      this.isSaving = false;
      this.$EdToast.create({ 
        msg:  `${this.$t('tools.staff.errors.userNoInvited')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    })
  }
  
  findPerson(email) {
    this.roles = ROLES_VALUES;
    StaffService.findPerson(email)
    .then((res) => {
      if(res.activeOrganizations.length > 0 && res.activeOrganizations.find(el => el.organizationId == this.orgId)) {
        this.$EdModal.createConfirmationModal(
          {
            body: `${this.$t('tools.staff.info.personBelongs', {userName: res.firstName})}`, 
            action: async () => {
              this.init();
              this.roleSelected = '';
            }
          }
        );
      } else if (res.activeOrganizations.length > 0 && res.activeOrganizations.find(el => el.organizationId !== null)) {
        this.$EdModal.createConfirmationModal(
          {
            body: `${this.$t('tools.staff.info.personBelongsOtherOrg', {userName: res.firstName})}`, 
            action: async () => {
              this.init();
              this.roleSelected = '';
            }
          }
        );
      } else if (res.activeOrganizations.length > 0 && res.activeOrganizations.find(el => el.organizationId === null)) {
        let role = res.activeOrganizations.find(el => el.organizationId === null).role
        this.init(res.firstName, res.lastName, res.email);
        this.roleSelected = role;
        this.disableRoles(role);
        this.form.email.valid = true;
      }
    })
  }

  disableRoles(role) {
    if (role == 'STUDENT') {
      this.roles = this.roles.map(el => {
        if(el.value !== 'STUDENT') {
          return {...el, disabled: true}
        } else return el
      })
    } else {
      this.roles = this.roles.map(el => {
        if(el.value == 'STUDENT') {
          return {...el, disabled: true}
        } else return el
      })
    }
  }

  /* Hooks */
  created() {
    this.init();
  }
}